import React from 'react'

export const Supporter = ({ name, caption, logo, des }) => {
    return (
        // This is the Supporter card
        <div className='flex flex-col w-80 max-sm:w-60'>

            {/* // This is the image */}
            <div className='bg-transparent rounded-xl w-full h-56'>
                <img src={logo} alt={`${name} logo`} className='w-full h-full' />
            </div>

            {/* // This is the title */}
            <h3 className='font-semibold text-2xl mt-2'>
                {name}
            </h3>

            {/* // This is the description */}
            <p className='mt-3 font-base text-sm text-zinc-500'>
                {caption}
            </p>

            {/* // This is the Comments */}
            <p className='mt-3 text-sm'>
                {des || 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit saepe, blanditiis officiis beatae reprehenderit at nesciunt voluptas laborum velit'}
            </p>

            {/* // This is the buttons */}
            <div className='mt-3 flex flex-wrap gap-3'>
                <button className='p-2 bg-blue-500 rounded-full'>

                </button>
                <button className='p-2 bg-blue-500 rounded-full'>

                </button>
                <button className='p-2 bg-blue-500 rounded-full'>

                </button>
            </div>
        </div>
    )
}
